import { ref } from 'vue'
import { secondsToMilliseconds } from 'date-fns'
import type { Variant } from '@/shared/types/common.types'
import type { Toast } from '../types/toast.types'

const toasts = ref<Toast[]>([])

let count = 0

export const useToaster = () => {
  const remove = (id: number) => {
    const current = toasts.value.find((toast) => toast.id === id)
    if (current?.timerId) {
      clearTimeout(current.timerId)
    }
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
  }

  const show = (variant: Variant, key: string, params?: Record<string, any>): void => {
    const id = count++
    const toast: Toast = { id, message: key, params, variant, progress: 100 }
    toast.timerId = setTimeout(() => {
      remove(id)
    }, secondsToMilliseconds(3))
    toasts.value.push(toast)
  }

  const success = (key: string, params?: Record<string, any>) => show('success', key, params)
  const error = (key: string, params?: Record<string, any>) => show('error', key, params)
  const info = (key: string, params?: Record<string, any>) => show('info', key, params)
  const warning = (key: string, params?: Record<string, any>) => show('warning', key, params)

  return { toasts, success, error, info, warning, remove }
}
